import { __decorate } from "tslib";
import { Message, MessageParamDefinition } from 'ircv3';
/**
 * @private
 */
export class ClearMsg extends Message {
    get date() {
        const timestamp = this._tags.get('tmi-sent-ts');
        return new Date(Number(timestamp));
    }
    get userName() {
        return this._tags.get('login');
    }
    get targetMessageId() {
        return this._tags.get('target-msg-id');
    }
}
ClearMsg.COMMAND = 'CLEARMSG';
__decorate([
    MessageParamDefinition({
        type: 'channel'
    })
], ClearMsg.prototype, "channel", void 0);
__decorate([
    MessageParamDefinition({
        trailing: true
    })
], ClearMsg.prototype, "message", void 0);
